/**
 * Global overlay stack — portals fixed overlays to <body> and assigns ascending
 * z-index so the most recently opened layer always paints on top.
 */
(function () {
  const PARENT_KEY = '__pbOverlayParent';
  const SIBLING_KEY = '__pbOverlaySibling';
  const layers = [];

  function readBase() {
    const raw = getComputedStyle(document.documentElement)
      .getPropertyValue('--layer-overlay-stack-base')
      .trim();
    const parsed = parseInt(raw, 10);
    return Number.isFinite(parsed) ? parsed : 40;
  }

  function inheritThemeVariables(element) {
    let section = element.closest('[id^="shopify-section-"]');

    if (!section && element.id?.startsWith('pb-ap-modal-')) {
      section = document.getElementById(
        'shopify-section-' + element.id.replace('pb-ap-modal-', '')
      );
    }

    if (!section) {
      return;
    }

    const computed = getComputedStyle(section);

    for (let i = 0; i < computed.length; i++) {
      const name = computed[i];
      if (name.startsWith('--pb-ap-') || name === '--pb-ap-font-family') {
        element.style.setProperty(name, computed.getPropertyValue(name));
      }
    }

    let brandWrapper = element.closest('.pb-ap-wrapper');
    if (!brandWrapper) {
      brandWrapper = section.querySelector('.pb-ap-wrapper');
    }

    if (brandWrapper) {
      const brandComputed = getComputedStyle(brandWrapper);
      const fontFamily = brandComputed.getPropertyValue('--pb-ap-font-family');
      if (fontFamily) {
        element.style.setProperty('--pb-ap-font-family', fontFamily);
      }
    }
  }

  // De Pick & Mix popups die naar <body> geportaleerd worden en daar hun
  // --pbpm-* waarden kwijtraken. Staat er een nieuwe popup bij, dan moet hij hier
  // ook in, anders valt hij terug op de standaardkleuren en het standaardfont.
  const PICK_MIX_POPUPS = '.pb-pm-product-popup, .pb-pm-smyle-gift, .pb-pm-gift';

  function inheritPickMixVariables(element) {
    const popup = element.matches?.(PICK_MIX_POPUPS)
      ? element
      : element.closest?.(PICK_MIX_POPUPS);

    if (!popup) {
      return;
    }

    const sectionId = popup.dataset?.sectionId;
    let source = popup.closest('.pb-pm');

    if (!source && sectionId) {
      source = document.getElementById(`PBPickMix-${sectionId}`);
    }

    if (!source) {
      return;
    }

    const computed = getComputedStyle(source);

    for (let i = 0; i < computed.length; i++) {
      const name = computed[i];
      if (name.startsWith('--pbpm-') || name.startsWith('--pb-pm-')) {
        popup.style.setProperty(name, computed.getPropertyValue(name));
      }
    }
  }

  function mountToBody(element) {
    if (!element || element.parentElement === document.body) {
      return;
    }

    const scrollY = window.scrollY;

    element[PARENT_KEY] = element.parentElement;
    element[SIBLING_KEY] = element.nextSibling;
    document.body.appendChild(element);
    window.scrollTo(0, scrollY);
  }

  function restoreFromBody(element) {
    if (!element || !element[PARENT_KEY]) {
      return;
    }

    const parent = element[PARENT_KEY];
    const sibling = element[SIBLING_KEY];

    if (sibling && sibling.parentElement === parent) {
      parent.insertBefore(element, sibling);
    } else {
      parent.appendChild(element);
    }

    delete element[PARENT_KEY];
    delete element[SIBLING_KEY];
  }

  function repaint() {
    const base = readBase();

    for (let i = 0; i < layers.length; i++) {
      layers[i].style.zIndex = String(base + i);
    }
  }

  function push(element) {
    if (!element) {
      return;
    }

    const existingIndex = layers.indexOf(element);
    if (existingIndex !== -1) {
      layers.splice(existingIndex, 1);
    }

    inheritThemeVariables(element);
    inheritPickMixVariables(element);
    mountToBody(element);
    element.setAttribute('data-pb-overlay-portaled', 'true');
    layers.push(element);
    repaint();
  }

  function pop(element) {
    if (!element) {
      return;
    }

    const index = layers.indexOf(element);
    if (index === -1) {
      return;
    }

    layers.splice(index, 1);
    element.removeAttribute('data-pb-overlay-portaled');
    restoreFromBody(element);
    element.style.zIndex = '';
    repaint();
  }

  window.PBOverlayStack = {
    push,
    pop,
    bringToFront: push,
  };
})();
